module.exports = __webpack_public_path__ + "img/ic-color-money.ff619159.svg";